import { createGlobalStyle } from "styled-components";

import { colors, fonts } from "../theme";

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    background: ${colors.bg};
    color: ${colors.ink};
    font-family: ${fonts.body};
    font-size: 16px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }

  h1, h2, h3 {
    font-family: ${fonts.title};
    font-weight: 400;
    margin: 0;
  }

  p {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    color: ${colors.goldText};
  }

  img {
    max-width: 100%;
  }

  :focus-visible {
    outline: 2px solid ${colors.gold};
    outline-offset: 3px;
  }
`;

export default GlobalStyle;
